import { APIClient, ChatStreamClient, IChatStreamParams, IChatStreamEvent } from '@innerhive-internal/innerhive-api-client';
import { ILink } from '../caremap/WithLinks';

// Re-export type for consumers
export type { IChatStreamEvent } from '@innerhive-internal/innerhive-api-client';

export interface IChatMessage {
    role: 'user' | 'assistant';
    content: string;
    createdAt: string;
}

export interface IChat {
    userId: string;
    chatId: string;
    messages: IChatMessage[];
    createdAt: string;
    lastMessageAt: string;
    links: {
        self: ILink;
    };
}

export class BeeChatClient {
    static inject = () => [APIClient, ChatStreamClient];

    constructor(
        private apiClient: APIClient,
        private chatStreamClient: ChatStreamClient
    ) {}

    getChats = async (): Promise<IChat[]> => {
        const entry = await this.apiClient.entry();
        if (!entry?.links?.chats) {
            return [];
        }
        const chats = await this.apiClient.get(entry.links.chats);
        chats.sort((a: IChat, b: IChat) => new Date(b.lastMessageAt).valueOf() - new Date(a.lastMessageAt).valueOf());
        return chats;
    };

    streamChat = (params: IChatStreamParams): AsyncGenerator<IChatStreamEvent> => {
        return this.chatStreamClient.streamChat(params);
    };
}
